export const withCacheErrorHandling: (
  cacheKey: string
) => (target: unknown, propertyKey: string, descriptor: PropertyDescriptor) => PropertyDescriptor = (
  cacheKey: string
) => {
  return function (target: unknown, propertyKey: string, descriptor: PropertyDescriptor) {
    const originalMethod = descriptor.value;

    descriptor.value = function (...args: unknown[]) {
      try {
        return originalMethod.apply(this, args);
      } catch {
        this.appStateCacheService.delete(cacheKey);
        return null;
      }
    };

    return descriptor;
  };
};
